import { Component } from "../extends";

export default () =>
	class SiteHeader extends Component() {
		events() {
			this.$EE.on("SiteMobileMenu:focus-last", () =>
				this.focusHamburger()
			);
			this.$EE.on("SiteMobileMenu:focus-first", () => this.focusLogo());
		}

		mounted() {
			this.logo = this.el.querySelector(".c-site-header__site-logo");
			this.hamburger = this.el.querySelector(
				".c-site-header__site-hamburger"
			);
		}

		onKeydown(e) {
			if (!this.$Store.isSiteMobileNavOpen) {
				return;
			}

			const isShift = e.shiftKey;
			const focusedEl = document.activeElement;

			if (this.hamburger === focusedEl && isShift) {
				this.$EE.emit("SiteHeader:focus-out-hambuger");
				e.preventDefault();
			}
		}

		focusLogo() {
			this.logo.focus();
		}

		focusHamburger() {
			this.hamburger.focus();
		}
	};
